(function () {
  'use strict'

  // Modal Window
  // ----------------------------------------

  function closeAllModals() {
    $( 'body' ).removeClass( 'overflow-y-hidden' ).css('padding-right', '0')

    let modals = $( '.modal' )

    Array.prototype.slice.call(modals).forEach((modal) => {
      $(modal).css( 'display','none' )
    })
  }

  function getScrollBarWidth() {
    var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body')
    var widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth()
    $outer.remove()
    return 100 - widthWithScroll
  }

  window.openModal = function (modalId) {
    $('#' + modalId).css( 'display','block' )
    $( 'body' ).addClass( 'overflow-y-hidden' ).css('padding-right', getScrollBarWidth() + 'px')
  }

  window.closeModal = function (modalId) {
    $( '#' + modalId ).css( 'display' , 'none' )
    $( 'body' ).removeClass( 'overflow-y-hidden' ).css('padding-right', '0')
  }

  document.onkeydown = function (event) {
    event = event || window.event

    if (event.keyCode === 27) {
      closeAllModals()
    }
  }

  window.openDynamicModal = function (modalId, el) {
    const modal = $( '#' + modalId )
    const loadingSpinner = modal.find( '.loadingSpinner' )
    const dynamicContent = modal.find( '.dynamicContent' )

    loadingSpinner.removeClass( 'hidden' );
    dynamicContent.empty();
    
    openModal( modalId )

    $.ajax({
        url: $(el).attr( 'href' ),
        type: 'GET',
        success: function (response) {
            loadingSpinner.addClass( 'hidden' );
            dynamicContent.html(response);
            initDatagrid( modalId );
        },
        error: function () {}
    })
  }
})()
